import { _ } from "../../core/polyglot/polyglot.js";
import Period from "./Period.js";

/**
 * `quarter` is a period representing a quarter of a year.
 * Instances should not be created by hand, but rather looked up
 * from `fiscalYear`.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} quarter
 */
export default class Quarter extends Period {
	constructor(spec) {
		super(spec);
		this._name = _("Q{index}", { index: this.getPeriodIndex() });
		this._periodId = `Q${this.getPeriodIndex()}`;
	}

	isQuarter() {
		return true;
	}

	getGroupLabel() {
		return _("Year");
	}

	static getType() {
		return "Quarter";
	}
}
